module.exports = __webpack_public_path__ + "static/media/293854.deabde0b.png";